import { createMuiTheme } from '@material-ui/core/styles';

export default createMuiTheme({
  palette: {
    primary: {
      light: '#424242',
      main: '#222222',
      dark: '#000000',
      contrastText: '#fff'
    }
  }
});
